<template>
  <div class="banner-wrapper">
    <div class="banner-content max-page">
      <swiper
        ref="mySwiper"
        :options="swiperOptions"
        @swiper="onSwiper"
        @click="goToPlay"
        @slideChange="onSlideChange"
      >
        <swiper-slide
          v-for="(item, index) in slideUrls.contents"
          :key="index + item.content_id"
        >
          <a
            class="log-click"
            :href="'/player/?mid=' + item.mid + '&cid=' + channel_id"
            :data-mid="item.mid"
            :data-vid="item.vid"
            :data-stp="item.stp"
            :data-template="slideUrls.template"
            :data-blockid="slideUrls.id"
            target="_blank"
          >
            <img
              :src="item.picture01"
              alt=""
            >
            <!-- <div class="swip-img" :style="{background:'url(' + item.picture01 + ')'}"></div> -->
            <div class="slide-content-box">
              <p
                class="name"
                v-if="item.name"
              >{{item.name}}</p>
              <p
                class="actor"
                v-if="item.actor"
              >主演：<span>{{item.actor}}</span></p>
              <p
                class="desc"
                v-if="item.aword"
              >{{item.aword}}</p>
            </div>
          </a>
        </swiper-slide>
        <div
          class="swiper-pagination"
          slot="pagination"
        ></div>
      </swiper>
      <div class="swiper-button-box">

        <div class="swiper-button swiper-button-prev"></div>
        <div class="swiper-button swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import 'swiper/swiper-bundle.min.css' // 导入样式
import {
  Swiper,
  SwiperSlide
} from 'vue-awesome-swiper' // 使用大佬包装的组件
import SwiperCore, { // 使用swiper6的模组扩展
  Autoplay,
  Navigation,
  Pagination
} from 'swiper'
// Import Swiper styles
SwiperCore.use([Pagination, Autoplay, Navigation]) // 注册模块 Navigation

export default {
  name: 'Banner',
  props: {
    slideUrls: {
      type: Object,
      default: function () {
        return {}
      }
    },
    channel_id: {
      type: String,
      default: ''
    }
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOptions: {
        slidesPerView: 1,
        grabCursor: true,
        spaceBetween: 0,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      params: {
        nav_id: 1,
        cl: 'newweb_baofeng',
        pg: 1
      },
      pageInfo: {}
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  methods: {
    onSwiper (swiper) {
      // console.log(swiper)
    },
    onSlideChange () {
      // console.log('slide change');
    },
    goToPlay () {
      // console.log('click');
    }
  },
  mounted () {
    // console.log('Current Swiper instance object', this.swiper)
    // this.swiper.slideTo(1, 1000, false)
  }

}
</script>
<style lang="less" scoped>
.banner-wrapper {
  text-align: center;
  background: #000;
  min-height: 311px;
  // min-height: 410px;
  // overflow: hidden;
  // position: relative;
  .banner-content {
    // width: 1600px;
    // margin: 0 auto;
    // img{
    //     position: absolute;
    //     left: 0;
    // }
    .swiper-button-box {
      position: relative;
      top: -200px;
    }
  }
  .swiper-container {
    img {
      width: 100%;
    }
    .swiper-pagination {
      height: 50px;
      text-align: right;
      bottom: 0px;
      background: linear-gradient(180deg, rgba(22, 22, 28, 0) 0%, #16161c 100%);
      .swiper-pagination-bullet {
        margin-top: 20px;
      }
    }
  }
  // .swiper-container, .swiper-wrapper, .swiper-slide{
  //     min-height: 410px;
  //     position: relative;
  // }
  .slide-content-box {
    position: absolute;
    bottom: 30px;
    left: 0;
    color: #fff;
    text-align: left;

    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    .name {
      font-size: 32px;
      line-height: 48px;
      font-weight: 500;
    }
    .actor {
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      width: 300px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .desc {
      font-size: 16px;
      line-height: 24px;
      color: rgba(255, 255, 255, 0.5);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/homePage/components/Banner.vue